//imgタグのSVGをcss操作する
import 'desvg';
export default class Desvg {
    init() {
        deSVG('.js-desvg', true)
    }
}